@include host-component-properties;

:host {
  --paf-result-timetable-list-button-gap: 40;
  --paf-result-timetable-list-vertical-space: 8;
  --paf-result-timetable-list-transition-duration: 300ms;
}

.result-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: px-to-rem(var(--paf-result-timetable-list-button-gap));
  transition: opacity ease-in var(--paf-result-timetable-list-transition-duration);
  opacity: 0;

  .result-list {
    margin: 0;
    padding: 0;
    max-width: 100%;
    flex-basis: 100%;
  }
}

.result-list-wrapper.visible {
  opacity: 1;
}
